import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Router, UrlSegment, UrlSegmentGroup, UrlTree } from '@angular/router';
import { ModalContentComponent } from '../components/modal-content/modal-content.component';
import { ModalConfirmComponent } from '../components/modal-confirm/modal-confirm.component';

@Injectable({
  providedIn: 'root',
})
export class UtilitiesService {
  /**
   * @property subModalHidden - subscripción al evento hidden de una referencia a un modal
   */
  private subModalHidden: Subscription;
  /**
   * @property bsModalRef - Referencia de un modal
   */
  public bsModalRef: BsModalRef;

  /**
   * Crea el servicio de utilidades
   * #constructor
   * @param modalService
   * @param router
   */

  constructor(private modalService: BsModalService,
              private router: Router
  ) { }

  /**
   * Obtiene los segmentos a partir de un path y según un filtro de opciones
   * @method getSegmentsFromPath
   * @param path
   * @param options
   * @returns
   */
  getSegmentsFromPath(path: string, options: { noLastSegment: boolean }): UrlSegment[] {
    const urlTree: UrlTree = this.router.parseUrl(path);
    const groupSegments: UrlSegmentGroup = urlTree.root.children['primary'];
    let segments = groupSegments ? groupSegments.segments : [new UrlSegment('', {})];
    if (groupSegments && options.noLastSegment) {
      segments = segments.filter((segment, index) => index < (groupSegments.segments.length - 1));
    }
    return segments
  }

  /**
   * Abre un modal informando algún texto pasado por parámetro
   *
   * @method openAlert
   * @param title
   * @param body
   * @param config
   */
  openAlert(title: string, body: string, config?: ModalOptions) {
    this.bsModalRef = this.modalService.show(ModalContentComponent, config);
    this.bsModalRef.content.title = title;
    this.bsModalRef.content.body = body;
  }

  /**
   * Abre un modal de confirmación
   * @method openConfirm
   * @returns
   * @param content
   * @param config
   */
  openConfirm(content: string, config?: ModalOptions): Promise<Subscription> {
    return new Promise<Subscription>((resolve, reject) => {
      this.subModalHidden = this.modalService.onHidden.subscribe(() => {
        if (this.bsModalRef.content.stateConfirm === 'YES') {
          resolve(this.subModalHidden);
        } else if (this.bsModalRef.content.stateConfirm === 'NO') {
          reject(this.subModalHidden);
        }
      });
      this.bsModalRef = this.modalService.show(ModalConfirmComponent, config);
      this.bsModalRef.content.content = content;
    });
  }

  /**
   * Convierte una cadena de caracteres a número
   * @example
   * stringToNumber('10') -> 10
   * stringToNumber('10s') -> 0
   * @method stringToNumber
   * @param str
   * @returns
   */
  stringToNumber(str: string): number {
    return isNaN(+str) ? 0 : +str;
  }


}
